import { cva, type VariantProps } from 'class-variance-authority';
import { ComponentProps, ReactNode } from 'react';

import styles from './badge.module.css';

const badge = cva(styles['badge'], {
  variants: {
    variant: {
      accent: styles['badge-accent'],
      warning: styles['badge-warning'],
      danger: styles['badge-danger'],
      success: styles['badge-success'],
      neutral: styles['badge-neutral'],
      gradient: styles['badge-gradient']
    },
    size: {
      micro: styles['badge-micro'],
      small: styles['badge-small'],
      regular: styles['badge-regular']
    },
    defaultVariants: {
      variant: 'accent',
      size: 'small'
    }
  }
});

type BadgeProps = VariantProps<typeof badge> &
  ComponentProps<'span'> & {
    icon?: ReactNode;
    children: ReactNode;
    className?: string;
    screenReaderText?: string;
  };

export const Badge = ({
  variant = 'accent',
  size = 'small',
  icon,
  children,
  className,
  screenReaderText,
  ...props
}: BadgeProps) => {
  return (
    <span
      className={badge({ variant, size, className })}
      data-slot='badge'
      {...props}
    >
      {icon && (
        <span className={styles['icon']} data-slot='badge-icon'>
          {icon}
        </span>
      )}
      {screenReaderText && (
        <span
          className={styles['sr-only']}
          data-slot='badge-screen-reader-text'
        >
          {screenReaderText}
        </span>
      )}
      {children}
    </span>
  );
};

Badge.displayName = 'Badge';
